import { Component, computed, createNgModule, inject, Injector, OnInit, signal, ViewChild, ViewContainerRef } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { MessagesStoreType, PopupService, ProductStateService } from '@mwe/services';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FeatureToggleEnum, MESSAGE_STORE_TOKEN } from '@mwe/constants';
import { HeaderLogoComponent } from '../../header-logo/header-logo.component';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { track } from '@mwe/utils';
import { EVENT_MEINE_NACHRICHTEN, MNRTrackOpenMenuData } from '@mwe/models';
import { ButtonComponent } from '../../buttons/button/button.component';
import { BadgeComponent } from '../../badge/badge/badge.component';

@Component({
  selector: 'mwe-navbar-header',
  templateUrl: './navbar-header.component.html',
  imports: [
    HeaderLogoComponent,
    NgClass,
    RouterLink,
    TranslateDirective,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    RouterLinkActive,
    TranslatePipe,
    ButtonComponent,
    BadgeComponent,
  ],
})
export class NavbarHeaderComponent extends NavbarComponent implements OnInit {
  private readonly productStateService = inject(ProductStateService);
  private readonly popupService = inject(PopupService);
  private readonly injector = inject(Injector);
  private readonly offcanvasService = inject(NgbOffcanvas);

  userName: string;
  emailAddress: string;

  @ViewChild('messagesComponent', { read: ViewContainerRef }) messageComponent!: ViewContainerRef;
  messagesStore = inject<MessagesStoreType>(MESSAGE_STORE_TOKEN);
  messagesPristine = signal<boolean>(true);
  messagesEnabled = computed<boolean>(() => this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.MESSAGES_ENABLED));

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.userName = this.accountLogic.getAccountFullName();
    this.emailAddress = this.accountLogic.getAccountEmail();
    if (this.messagesEnabled() && this.isLoggedIn) {
      this.messagesStore.loadMessages();
    }
  }

  resetProductState(): void {
    this.productStateService.clearRecentOrders();
  }

  logout(): void {
    this.popupService.openLogoutPopup();
  }

  async openMessagesOverlay() {
    this.messagesPristine.set(false);

    // eslint-disable-next-line @nx/enforce-module-boundaries
    const { MessagesModule } = await import('@mwe/features/messages');
    const module = createNgModule(MessagesModule, this.injector);
    const ref = this.offcanvasService.open(module.instance.getComponent(), { position: 'end' });
    ref.shown.subscribe(_ => {
      (document.getElementById('mm-list').querySelector("[role='tab']") as HTMLElement)?.focus();
    });
    ref.hidden.subscribe(_ => {
      this.messagesStore.setShowDetails(false);
      this.messagesStore.updateSelectedMessage(undefined);
    });
    track(EVENT_MEINE_NACHRICHTEN, new MNRTrackOpenMenuData());
  }
}
